import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const ColStyledLeft = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-right: ${mediumUp ? rem(60) : 0};
    `;
  }
}`;

export const ColStyledRight = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      h3, p {
        text-align: ${mediumUp ? 'left' : 'center'};
      }
      blockquote {
        margin-top: 0;
        margin-bottom: 0;
      }
      ::before {
        content: '';
        display: ${mediumUp ? 'none' : 'block'};
        border-top: ${mediumUp ? 'none' : `${rem(1)} solid ${theme.colors.neutral.gray}`};
        margin: 0 auto;
        width: ${rem(100)};
        padding-bottom: ${rem(30)};
      }
    `;
  }
}`;

export const DivStyledCardContainer = styled.div`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      border-left: ${mediumUp ? `${rem(1)} solid ${theme.colors.neutral.gray}` : 'none'};
      padding-left: ${mediumUp ? rem(40) : 0};
    `;
  }
}`;

export const TypographyStyled = styled(Typography)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? 0 : rem(24)};
    `;
  }
}`;

